module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"soap","commonjs":"soap","commonjs2":"soap","root":"soap"}
 ** module id = 49
 ** module chunks = 1
 **/